import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "@/components/feature/Pagination";
import { Breadcrumb } from "@/components/feature/Breadcrumb";
import { newsList } from "@/mocks/news";

const PAGE_SIZE = 6;

export default function NewsListPage() {
  const [page, setPage] = useState(1);

  useEffect(() => {
    document.title = "最新娱乐资讯 - 爱妻艺";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "关注影视娱乐圈动态，阅读原创影视新闻和深度报道。");
  }, []);

  const sorted = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1));
  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const paged = sorted.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "娱乐资讯" }]} />

      <header className="mt-4 border-b border-background-200 pb-5">
        <h1 className="flex items-center gap-3 text-2xl font-bold text-foreground-950 md:text-3xl">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
            <i className="ri-newspaper-line text-2xl"></i>
          </span>
          最新娱乐资讯
        </h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-500 md:text-base">
          关注影视娱乐圈动态，阅读原创影视新闻和深度报道，第一时间了解作品口碑、幕后故事与行业趋势。
        </p>
      </header>

      {paged.length > 0 ? (
        <ul className="mt-6 flex flex-col gap-5">
          {paged.map((item) => (
            <li key={item.id}>
              <Link
                to={`/news/${item.id}`}
                className="group flex cursor-pointer flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row md:p-5"
              >
                <div className="h-48 w-full shrink-0 overflow-hidden rounded-lg bg-background-100 sm:h-32 sm:w-52">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 爱妻艺娱乐资讯`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2 text-xs text-secondary-600">
                    <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                      {item.category}
                    </span>
                    <span>{item.date}</span>
                    <span className="flex items-center gap-0.5 text-foreground-400">
                      <i className="ri-eye-line"></i>
                      {item.views}
                    </span>
                  </div>
                  <h2 className="mt-2 text-base font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h2>
                  <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">
                    {item.summary}
                  </p>
                  <span className="mt-3 flex flex-wrap items-center gap-2">
                    {item.tags.map((tag) => (
                      <span key={tag} className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-500">
                        #{tag}
                      </span>
                    ))}
                    <span className="ml-auto flex items-center gap-1 whitespace-nowrap text-sm text-primary-600">
                      阅读全文
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <div className="mt-6 flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 py-16">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-newspaper-line text-3xl"></i>
          </span>
          <p className="mt-4 text-base font-medium text-foreground-800">暂无资讯</p>
          <p className="mt-1 text-sm text-foreground-500">资讯正在持续更新中，敬请期待</p>
        </div>
      )}

      <Pagination current={safePage} total={totalPages} onChange={setPage} />
    </div>
  );
}